<div class="outer-container">
  <mat-card class="question-card" [formGroup]="form">
    <mat-card-header>
      <mat-card-title class="card-title">
        Bitte beantworten Sie die allgemeinen Fragen zu Ihrer Anlage</mat-card-title
      >
    </mat-card-header>
    <hr class="separator" />

    <mat-card-content class="card-content">
      <h3>Welche Erzeugungstechnologie hat Ihre Anlage?</h3>
      <mat-radio-group
        class="radio-group"
        formControlName="generationTechnology"
        [disabledInteractive]="true"
      >
        @for (option of generationTechnologyOptions(); track option.value) {
          <div class="options-text">
            <mat-radio-button
              class="radio-button"
              [value]="option.value"
              id="technology-{{ option.value }}"
            >
              {{ option.label }}
              @if (option.tooltip) {
                <span class="custom-tooltip">
                  <img src="images/ic24-help.svg" alt="generation technology info" />
                  <div>
                    <span class="custom-tooltip-arrow"></span>
                    {{ option.tooltip() }}
                  </div>
                </span>
              }
            </mat-radio-button>
          </div>
        }
      </mat-radio-group>

      @if (showAdditionalQuestions()) {
        <h3>Ist für Ihre Anlage Eigenverbrauch vorgesehen?</h3>
        <mat-radio-group class="radio-group" formControlName="isForOwnConsumption">
          @for (option of isForOwnConsumptionOptions(); track option.label) {
            <div class="options-text">
              <mat-radio-button class="radio-button" [value]="option.value">
                {{ option.label }}
              </mat-radio-button>
            </div>
          }
        </mat-radio-group>

        <h3>Wie hoch ist die installierte Leistung Ihrer Anlage?</h3>
        <article class="slider">
          <section class="slider__labels">
            @for (option of installedCapacityOptions(); let i = $index; track option) {
              <span
                class="slider__labels__label"
                role="button"
                tabindex="0"
                (click)="setInstalledCapacity(i)"
                (keydown.enter)="setInstalledCapacity(i)"
                (keydown.space)="setInstalledCapacity(i)"
                [class.active]="form.get('installedCapacity')?.value === i"
                >{{ option }}</span
              >
            }
          </section>

          <mat-slider
            class="slider__track"
            [max]="installedCapacityOptions().length - 1"
            [min]="0"
            [showTickMarks]="true"
          >
            <input formControlName="installedCapacity" matSliderThumb />
          </mat-slider>
        </article>
      }
    </mat-card-content>
  </mat-card>
  <div>
    <button
      class="button"
      [ngClass]="isNextButtonEnabled() ? 'button-valid' : 'button-invalid'"
      [disabled]="!isNextButtonEnabled()"
      (click)="onClick()"
    >
      Weiter
    </button>
  </div>
</div>
